import Config from "./config"
import axios from 'axios'
import Sha256 from "./sha256";

var DataLayer = {
    getProducts() {
        let url = `${Config.wsHost}/api/excel/${Config.excelId}/${Config.productsSheet}/filter?skipRows=2`;
        let payload = {
            where: [],
            enhance: [
                { key: "Sitecore ID", type: "exact", fields: ["ImageUrl", "Subtitle", "Description", "Url"]}
            ]
        };
        return axios.post(url, payload);
    },
    getFilters() {
        let url = `${Config.wsHost}/api/excel/${Config.excelId}/${Config.filtersSheet}`;
        return axios.get(url);
    },
    computeSignature(params) {
        if (!params) return "";
        var sha = new Sha256();
        return sha.update(`${params.userId}||${params.filters}`).digest("hex");
    },
    getCookieValue(name) {
        var res = decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(name).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
        if (res) return res;
        else return "";
    },
    getSelectedOptionsLabels(selectedOptions) {
        if (!selectedOptions || selectedOptions.length === 0) return "";
        return selectedOptions.join("|");
    },
    recordFilters(selectedOptions, prodCount) {
        let params = {
            id: 0,
            userId: this.getCookieValue("CLAUserID"),
            filters: this.getSelectedOptionsLabels(selectedOptions),
            productCount: prodCount
        };
        params.signature = this.computeSignature(params);
        let url = `${Config.wsHost}/api/tracking/${Config.appName}/Filters`;
        return axios.post(url, params);
    },
    recordProduct(product) {
        if (!product) return Promise.reject("No product to record! Please check your code.");
        let params = {
            id: 0,
            userId: this.getCookieValue("CLAUserID"),
            filters: this.getSelectedOptionsLabels(),
            productId: product["Sitecore ID"],
            productName: product.Product,
            productUrl: product.Url
        };
        params.signature = this.computeSignature(params);
        let url = `${Config.wsHost}/api/tracking/${Config.appName}/Product`;
        return axios.post(url, params);
    }
};

export default DataLayer;